// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3243":"ff1b6a26","5786":"07407696","6121":"197bdf14"}[chunkId] + ".chunk.css";
};